import { styled } from "styled-components";
import { Lozenge } from "@gnist/design-system";
import Image, { StaticImageData } from "next/image";
import React, { useState } from "react";
import defaultThumbnail from "@/public/images/defaultCar-thumbnail.jpg";
import { tokens } from "@gnist/themes/tokens.css.js";

const ImageDiv = styled.div`
  position: relative;
  display: block;
  padding-top: 66.6%; // define height of image relative to its width
`;

const SoldBanner = styled.div`
  position: absolute;
  bottom: ${tokens.spacing.xs};
  left: ${tokens.spacing.xs};

  p {
    text-transform: capitalize;
  }
`;

const AvailableFromBanner = styled.div`
  position: absolute;
  top: 0;
  background: var(--moller-color-surface-variant);
  color: var(--moller-color-on-background);
  font-weight: 500;
  padding: 5px 10px;
  right: 0;
  font-size: 0.8rem;
`;


type props = {
  thumbnailImageUrl: string | StaticImageData;
  isSold: boolean;
  width?: number;
  height?: number;
  availableFromDate?: string;
};

const CarThumbnailImage = ({
  thumbnailImageUrl,
  width,
  height,
  isSold,
  availableFromDate
}: props) => {
  const [isValidUrl, setIsValidUrl] = useState<boolean>(true);

  return (
    <ImageDiv>
      <Image
        src={isValidUrl ? thumbnailImageUrl : defaultThumbnail}
        alt=""
        loader={(img) => img.src}
        unoptimized={true}
        width={width}
        height={height}
        onError={() => setIsValidUrl(false)}
        fill={!(width || height)}
        sizes={width || height ? undefined : "100%, 100%"}
        style={{ objectFit: "cover" }}
      />
      {isSold && (
        <SoldBanner>
          <Lozenge colorVariant="warning">
            <p>Solgt</p>
          </Lozenge>
        </SoldBanner>
      )}
      {availableFromDate && <AvailableFromBanner>Tilgjengelig fra {new Date(availableFromDate).toLocaleDateString(
        "no-NO",
        {
          month: "long",
          day: "numeric",
        })}</AvailableFromBanner>}
    </ImageDiv>
  );
};

export default CarThumbnailImage;
